export default {
  'pages.category.title1': '一级分类',
  'pages.category.title2': '二级分类',
  'pages.category.title3': '三级分类',
  'pages.category.allGoods': '所有商品',
  'pages.category.empty': '暂无此类商品，敬请期待！',
  'pages.category.total': '共',
  'pages.category.unity': '件商品',
  'pages.category.del': '清空筛选',
  'pages.category.allCategory': '全部分类',
  'pages.category.news': '最新报道',
  'pages.category.ours': '关于我们',
  'pages.category.name': '分类',
  'pages.category.more': '更多',
  'pages.category.close': '收起',
  'pages.category.merch': '商品分类筛选',
  'pages.category.attr': '特质分类筛选',
};
